// Import the global requirements
import React from 'react'
import { createRoot } from 'react-dom/client'

// Import the component from the package
import { SignUpLoginModal } from '@wantable/Header'
import { useAuth } from "@wantable/Shared/Hooks";

// declare the id of the element to be used where the component will be rendered
const rootEl = document.getElementById('modal')

function isHidden(el) {
  return (el ? el.firstChild === null : null)
}

let root = createRoot(rootEl);
let elementHidden = isHidden(document.getElementById('modal'));

const onAfterLogin = () => {
  console.log("Login Successful");
  const tokenValue = JSON.parse(localStorage.getItem('wantable-shopify-token'))
  let signInRedirect = window.WANTABLE_header?.signInRedirect ? window.WANTABLE_header?.signInRedirect : "/"

  if (tokenValue) {
    if (tokenValue && tokenValue.shopifyToken) {
      window.location.href = "/account/login/multipass/" + tokenValue.shopifyToken.token + "?return_to=" + signInRedirect
    }
  }
}

/**
 * Clears user data in localStorage
 *
 * @param {HTMLElement} element - Creates react root and renders SignUpLoginModal
 * @param {"login"|"signup"} modalType
 */
const createRootAndRender = (element, modalType) => {
  const root = createRoot(element)
  element && root.render(<SignUpLoginModal modalType={modalType} onAfterLogin={onAfterLogin} />)
}

/**
 * Clears user data in localStorage
 *
 * @param {String} elementID - Adds click action to if exists
 */
const addClearStorageListener = (elementID) => {
  if (document.getElementById('sideBarSignOut') === null) return;
  document.getElementById('sideBarSignOut').addEventListener("click", function() {
    useAuth().logout();
  })
}

/**
 * Clears user data in localStorage
 *
 * @param {String} elementID - Element to add listener to if exists
 * @param {"login"|"signup"} modalType
 */
const addClickListenerSignUpLoginModal = (elementID, modalType) => {
  if (document.getElementById(elementID) === null) return;

  document.getElementById(elementID).addEventListener("click", function() {
    if (elementHidden === true) {
      rootEl && root.unmount()

      createRootAndRender(rootEl, modalType)
    }
  })
}

/**
 * Renders login/signup modal based on account pathname
 *
 * @param {String} pathname
 * @param {String} elementID - Element to become the root of the modal
 * @param {"login"|"signup"} modalType
 */
const renderSignUpLoginModalByPath = (pathname, elementID, modalType) => {
  if (window.location.pathname != pathname) return;

  const headlessElement = document.getElementById(elementID);

  if(headlessElement === null) return;

  createRootAndRender(headlessElement, modalType)
}

if (window.location.pathname.startsWith("/pages/multipass")) {
  // Coming from a link on WWW and WWW passed a multipass token, capture that token
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get('token');
  const uid = urlParams.get('uid');

  // set the minimum info needed to hit the WWW api
  const tokenData = JSON.stringify({
    shopifyToken: {
      token: token
    },
    shopifyUID: uid
  });
  localStorage.setItem("wantable-shopify-token", tokenData);

  // remove any previous cached user so it refetches and it'll fetch and set the entire token
  localStorage.removeItem("wantable-user-data");
  onAfterLogin()
}

if (window.location.pathname.startsWith("/pages/logout")) {
  localStorage.removeItem("wantable-shopify-token");
  localStorage.removeItem("wantable-user-data");
  window.location.href = '/account/logout';
}

// Shopify Sign In / Sign Out Functions
addClickListenerSignUpLoginModal('sideBarSignIn', 'login');
addClickListenerSignUpLoginModal('sideBarCreateAccount', 'signup');

window.addEventListener("wishlistloginRequired", (e) => {
  let signInRedirect = window.location.href.replace(window.location.origin, '');
  if (elementHidden === true) {
    rootEl && root.unmount()
    let signInRedirect = window.location.href.replace(window.location.origin, '');
    window.WANTABLE_header.signInRedirect = signInRedirect;

    createRootAndRender(rootEl, 'login', e.detail)
  }
})

addClearStorageListener('sideBarSignOut');
addClearStorageListener('accountMenuSignOut');

// declare the id of the element to be used where the component will be rendered
renderSignUpLoginModalByPath('/account/login', 'headless-login', 'login')
renderSignUpLoginModalByPath('/account/register', 'headless-register', 'signup')
renderSignUpLoginModalByPath('/pages/account-reset', 'headless-account-reset', 'reset')

